import { useEffect } from 'react';

/**
 * MED-1383: name the browser tab for the current role. index.html said "Medley Admin"
 * on every page, so a coach saw an admin title. Each layout passes its own title.
 * On unmount the previous title comes back, so a login page after sign out reads
 * "Medley" again.
 */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
